<template>
  <div class="index_con">
    <!-- 进度条 -->
    <div class="floating" id="abc">
      <span class="bmeter" style="width: 0%;"></span>
    </div>
    <div class="i_w980">
      <div class="w980"></div>
    </div>
    <!-- 进度条 end -->

    <div class="i_ban" v-if="bannerMode">
      <swiper :modules="modules" v-bind="swiperBanner">
        <template v-for="(item, index) in bannerInfo" :key="item.id">
          <swiper-slide>
            <div class="img "
              :style="{ background: `url(${formatImg(item.image)}) no-repeat center `, backgroundSize: 'cover' }">
              <video :src="`${formatImg(item.image)}`" muted autoplay loop></video>
              <div class="cover"></div>
            </div>
            <div
              class="txt "
              :class="`place${item.isData}`"
              :style="{ color: `${item.color}`, cursor: item.url ? 'pointer' : '' }"
              @click="jumpUrl(item.url)"
            >
              <div class="tit" v-html="item.title"></div>
              <div class="con" v-html="item.subhead"></div>
            </div>
          </swiper-slide>
        </template>
        <div class="btn">
          <div class="prev"></div>
          <div class="next"></div>
        </div>
        <div class="swiper-pagination"></div>
      </swiper>
    </div>

    <div class="i_part1" v-else>
      <div class="mx_pic parallaxto1"
        :style="{ background: `url(${formatImg(aniBannerInfo?.image)}) no-repeat  center`, backgroundSize: 'cover' }">
        <div class="pic_box">
          <div class="txt  ">
            <div class="cn f_55" v-html="aniBannerInfo?.title"></div>
            <div class="en f_28" v-html="aniBannerInfo?.subhead"></div>
            <a @click="switchTab(aniBannerInfo?.url)" class="btn f_16">
              <span>{{ t('index.more') }}</span>
            </a>
          </div>
          <!-- <div class="img"> -->
          <img src="@/assets/video/index_model/1.png" alt="" class="parallax_ll">
          <!--  -->
          <!-- </div> -->
        </div>
      </div>
      <div class="boxs">
        <div class="txt parallaxto2"></div>
      </div>
      <div class="i_partis">
        <div class="i_parti">
          <div class="boxs hide">
            <div class="box"></div>
            <div class="box"></div>
            <div class="box"></div>
            <div class="box"></div>
          </div>
          <div class="pic_box">
            <div class="pic on"></div>
            <div class="pic"></div>
            <div class="pic"></div>
            <div class="pic"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="i_part1 m">
      <swiper :modules="modules" v-bind="swiper1m">
        <template v-for="(item, index) in mBannerInfo" :key="item.id">
          <swiper-slide>
            <div class="img "
              @click="jumpUrl(item.url)"
              :style="{ background: `url(${formatImg(item.image)}) no-repeat center `, backgroundSize: '100% auto' }">
              <div class="txt " :class="`place${item.isData}`">
                <div class="tit" :style="{ color: `${item.color}` }" v-html="item.title"></div>
                <div class="con" :style="{ color: `${item.color}` }" v-html="item.subhead"></div>
              </div>
            </div>
          </swiper-slide>
        </template>
        <div class="swiper-pagination"></div>
      </swiper>
    </div>

    <div class="ip37">
      <img src="@/assets/imgm/impgbg.png" alt="" class="pgbgm">
      <div class="i_part3" v-if="modelList?.length > 0 || modelList">
        <div class="tit">
          <div class="h1 f_36" v-html="ip2title?.title"></div>
          <div class="h2 f_24 " v-html="ip2title?.subhead"></div>
        </div>
        <div class="boxs">
          <template v-for="item in modelList" :key="item.id">
            <div class="box" @click="switchTab(`/ProductList/${item.productLineName}`)" data-wow-delay="300ms">
              <div class="txt">
                <div class="h f_18">{{ item.productLineName }}</div>
                <div class="p f_15" v-html="item.intro"></div>
              </div>
              <div class="bottom">
                <div class="txt1">
                  <template v-for="item1 in item.cardModelDetailsList" :key="item1.id">
                    <div class="item">
                      <div class="h f_16">{{ item1.productLineName }}</div>
                      <div class="p f_14">{{ item1.intro }}</div>
                    </div>
                  </template>
                </div>
                <div class="pic">
                  <img :src="formatImg(item.image)" alt="">
                </div>
              </div>
            </div>
          </template>

        </div>
        <div class="boxs m">
          <swiper :modules="modules" v-bind="swiper3m">
            <template v-for="(item, index) in modelList" :key="item.id">
              <swiper-slide @click="switchTab(`/ProductList/${item.productLineName}`)">
                <div class="item" data-wow-delay="300ms">
                  <div class="txt">
                    <div class="h f_20">{{ item.productLineName }}</div>
                    <div class="p f_16" v-html="item.intro"></div>
                  </div>
                  <div class="txt1">
                    <template v-for="item1 in item.cardModelDetailsList" :key="item1.id">
                      <div class="litem">
                        <div class="h f_16">{{ item1.productLineName }}</div>
                        <div class="p f_14">{{ item1.intro }}</div>
                      </div>
                    </template>
                  </div>
                  <div class="pic">
                    <img :src="formatImg(item.image)" alt="">
                  </div>
                </div>
              </swiper-slide>
            </template>
            <div class="swiper-scrollbar"></div>
          </swiper>

        </div>
      </div>
      <div class="i_part4fixed"></div>
      <div class="i_part4" v-if="recommendIndustry?.length > 0 || recommendIndustry">
        <!--<img src="./img/ip4.png" alt="" class="bg"> -->
        <div class="boxss">
          <!--<img src="./img/ip4.png" alt="" class="bg">-->
          <div class="txt">
            <div class="h1 f_24 " data-wow-delay="00ms" v-html="ip3title?.title"></div>
            <div class="h2  f_34" data-wow-delay="100ms" v-html="ip3title?.subhead">
            </div>
          </div>

          <div class="boxs ">
            <div class="txt">
              <div class="h1 f_24 " data-wow-delay="00ms" v-html="ip3title?.title"></div>
              <div class="h2  f_36" data-wow-delay="100ms" v-html="ip3title?.subhead"></div>
            </div>

            <template v-for="item in recommendIndustry" :key="item.id">

              <div class="box">
                <a @click="switchTab(`/industry/${item[0]?.name}`)" class="b_left">
                  <div class="img "
                    :style="{ background: `url(${formatImg(item[0]?.recommendImage)}) no-repeat center `, backgroundSize: 'cover' }">
                  </div>
                  <!-- <img :src="formatImg(item[0]?.recommendImage)"
                       alt=""> -->
                  <div class="txt">
                    <div class="h f_24" v-html="item[0]?.name"></div>
                    <div class="solid"></div>
                    <div class="p f_14" v-html="item[0]?.recommendIntro"></div>
                    <div class="btn f_16">{{ t('index.more') }}</div>
                  </div>
                </a>
                <a class="b_right" @click="switchTab(`/industry/${item[1]?.name}`)">
                  <div class="pic">
                    <div class="img "
                      :style="{ background: `url(${formatImg(item[1]?.recommendImage)}) no-repeat center `, backgroundSize: 'cover' }">
                    </div>
                    <!-- <img :src="formatImg(item[1]?.recommendImage)"
                         alt=""> -->
                    <div class="txt1">
                      <div class="h f_24" v-html="item[1]?.name"></div>
                      <div class="solid"></div>
                    </div>
                  </div>
                  <div class="txt2">
                    <div class="p f_14" v-html="item[1]?.recommendIntro"></div>
                    <div class="btn f_16">{{ t('index.more') }}</div>
                  </div>
                </a>
              </div>
            </template>

          </div>
        </div>
      </div>

      <div class="i_part4m" v-if="recommendIndustry?.length > 0 || recommendIndustry">
        <div class="title" v-html="ip3title?.subhead"></div>
        <div class="desc" v-html="ip3title?.title"></div>

        <div class="boxs ">

          <swiper :modules="modules" v-bind="swiper4m">
            <template v-for="item in recommendIndustry" :key="item.id">
              <swiper-slide>
                <a @click="switchTab(`/industry/${item[0]?.name}`)" class="b_left">
                  <img :src="formatImg(item[0]?.recommendImage)" alt="">
                  <div class="txt">
                    <div class="tit" v-html="item[0]?.name"></div>
                    <div class="solid"></div>
                    <div class="con" v-html="item[0]?.recommendIntro"></div>
                    <div class="btn ">{{ t('index.more') }} <i></i></div>
                  </div>
                </a>
              </swiper-slide>
              <swiper-slide v-if="item[1]">
                <a class="b_right" @click="switchTab(`/industry/${item[1]?.name}`)">
                  <div class="pic"
                    :style="{ background: `url(${formatImg(item[1]?.recommendImage)}) no-repeat center `, backgroundSize: 'cover' }">

                    <div class="txt1">
                      <div class="tit" v-html="item[1]?.name"></div>
                      <div class="solid"></div>
                    </div>
                  </div>
                  <div class="txt2">
                    <div class="con" v-html="item[1]?.recommendIntro"></div>
                    <div class="btn ">{{ t('index.more') }} <i></i></div>
                  </div>
                </a>
              </swiper-slide>
            </template>
          </swiper>
        </div>
      </div>
      <div class="i_part5" v-if="serList?.length > 0 || serList">
        <div class="tit">
          <div class="h1 f_36 " data-wow-delay="00ms" v-html="ip4title?.title"></div>
          <div class="h2 f_24" data-wow-delay="100ms" v-html="ip4title?.subhead"></div>
        </div>
        <div class="boxs">

          <template v-for="item in serList" :key="item.id">
            <a @click="switchTab(item.url)" class="box" data-wow-delay="100ms">
              <img :src="formatImg(item.image)" alt="">
              <div class="txt">
                <div class="h1 f_18" v-html="item.title"></div>
                <div class="h2 f_24" v-html="item.intro"></div>
                <div class="btn f_16">{{ t('index.more') }}</div>
              </div>
            </a>
          </template>
        </div>
      </div>
      <div class="ip_67" v-if="recommendNews?.length > 0 || recommendNews">

        <div class="i_part6">
          <!--<img src="./img/ip6.png" alt="" class="bg">-->
          <div class="tit">
            <div class="h1 f_36 " data-wow-delay="00ms">{{ t('index.jakaNews') }}</div>
            <div class="h2 f_24" data-wow-delay="100ms">{{ t('index.jakaShare') }}</div>
          </div>

          <div class="list">

            <template v-for="item in recommendNews?.slice(0, 2)" :key="item.id">
              <a @click="switchTab(`/newsDetail/${item.id}`)" class="item">
                <div class="container">
                  <div class="name f_15">{{ t('index.weekNews') }}</div>
                  <div class="himgf">
                    <div class="img himg" :style="{ backgroundImage: `url(${formatImg(item.image)})` }">
                    </div>
                  </div>
                  <div class="txt">
                    <div class="tit line1 f_20">{{ item.title }}</div>
                    <div class="con line2 f_16" v-html="item.introduce"></div>
                    <div class="bottom">
                      <div class="nmore f_15">{{ t('index.explore') }}<i></i></div>
                      <div class="time f_18">{{ item.dateStr }}</div>
                    </div>
                  </div>
                </div>
              </a>
            </template>
            <div class="item nlist">
              <div class="name f_15">{{ t('index.weekNews') }}</div>
              <div class="container">
                <template v-for="item in recommendNews?.slice(2)" :key="item.id">
                  <a @click="switchTab(`/newsDetail/${item.id}`)" class="litem">
                    <div class="top">
                      <div class="tit line1 f_20">{{ item.title }}</div>
                      <div class="time f_18">{{ item.dateStr }}</div>
                    </div>
                    <div class="con line2 f_16" v-html="item.introduce"></div>
                  </a>
                </template>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div>
    <img src="@/assets/video/index_model/1.png" style="display: none;" class="img_1">
    <img src="@/assets/video/index_model/2.png" style="display: none;" class="img_2">
    <img src="@/assets/video/index_model/3.png" style="display: none;" class="img_3">
    <img src="@/assets/video/index_model/4.png" style="display: none;" class="img_4">
    <img src="@/assets/video/index_model/5.png" style="display: none;" class="img_5">
    <img src="@/assets/video/index_model/6.png" style="display: none;" class="img_6">
    <img src="@/assets/video/index_model/7.png" style="display: none;" class="img_7">
    <img src="@/assets/video/index_model/8.png" style="display: none;" class="img_8">
    <img src="@/assets/video/index_model/9.png" style="display: none;" class="img_9">
    <img src="@/assets/video/index_model/10.png" style="display: none;" class="img_10">
    <img src="@/assets/video/index_model/11.png" style="display: none;" class="img_11">
    <img src="@/assets/video/index_model/12.png" style="display: none;" class="img_12">
    <img src="@/assets/video/index_model/13.png" style="display: none;" class="img_13">
    <img src="@/assets/video/index_model/14.png" style="display: none;" class="img_14">
    <img src="@/assets/video/index_model/15.png" style="display: none;" class="img_15">
    <img src="@/assets/video/index_model/16.png" style="display: none;" class="img_16">
    <img src="@/assets/video/index_model/17.png" style="display: none;" class="img_17">
    <img src="@/assets/video/index_model/18.png" style="display: none;" class="img_18">
    <img src="@/assets/video/index_model/19.png" style="display: none;" class="img_19">
    <img src="@/assets/video/index_model/20.png" style="display: none;" class="img_20">
    <img src="@/assets/video/index_model/21.png" style="display: none;" class="img_21">
    <img src="@/assets/video/index_model/22.png" style="display: none;" class="img_22">
    <img src="@/assets/video/index_model/23.png" style="display: none;" class="img_23">
    <img src="@/assets/video/index_model/24.png" style="display: none;" class="img_24">
    <img src="@/assets/video/index_model/25.png" style="display: none;" class="img_25">
    <img src="@/assets/video/index_model/26.png" style="display: none;" class="img_26">
    <img src="@/assets/video/index_model/27.png" style="display: none;" class="img_27">
    <img src="@/assets/video/index_model/28.png" style="display: none;" class="img_28">
    <img src="@/assets/video/index_model/29.png" style="display: none;" class="img_29">
    <img src="@/assets/video/index_model/30.png" style="display: none;" class="img_30">
    <img src="@/assets/video/index_model/31.png" style="display: none;" class="img_31">
    <img src="@/assets/video/index_model/32.png" style="display: none;" class="img_32">
    <img src="@/assets/video/index_model/33.png" style="display: none;" class="img_33">
    <img src="@/assets/video/index_model/34.png" style="display: none;" class="img_34">
    <img src="@/assets/video/index_model/35.png" style="display: none;" class="img_35">
    <img src="@/assets/video/index_model/36.png" style="display: none;" class="img_36">
    <img src="@/assets/video/index_model/37.png" style="display: none;" class="img_37">
    <img src="@/assets/video/index_model/38.png" style="display: none;" class="img_38">
    <img src="@/assets/video/index_model/39.png" style="display: none;" class="img_39">
    <img src="@/assets/video/index_model/40.png" style="display: none;" class="img_40">
    <img src="@/assets/video/index_model/41.png" style="display: none;" class="img_41">
    <img src="@/assets/video/index_model/42.png" style="display: none;" class="img_42">
    <img src="@/assets/video/index_model/43.png" style="display: none;" class="img_43">
    <img src="@/assets/video/index_model/44.png" style="display: none;" class="img_44">
    <img src="@/assets/video/index_model/45.png" style="display: none;" class="img_45">
    <img src="@/assets/video/index_model/46.png" style="display: none;" class="img_46">
    <img src="@/assets/video/index_model/47.png" style="display: none;" class="img_47">
    <img src="@/assets/video/index_model/48.png" style="display: none;" class="img_48">
    <img src="@/assets/video/index_model/49.png" style="display: none;" class="img_49">
    <img src="@/assets/video/index_model/50.png" style="display: none;" class="img_50">
    <img src="@/assets/video/index_model/51.png" style="display: none;" class="img_51">
    <img src="@/assets/video/index_model/52.png" style="display: none;" class="img_52">
    <img src="@/assets/video/index_model/53.png" style="display: none;" class="img_53">
    <img src="@/assets/video/index_model/54.png" style="display: none;" class="img_54">
    <img src="@/assets/video/index_model/55.png" style="display: none;" class="img_55">
    <img src="@/assets/video/index_model/56.png" style="display: none;" class="img_56">
    <img src="@/assets/video/index_model/57.png" style="display: none;" class="img_57">
    <img src="@/assets/video/index_model/58.png" style="display: none;" class="img_58">
    <img src="@/assets/video/index_model/59.png" style="display: none;" class="img_59">
    <img src="@/assets/video/index_model/60.png" style="display: none;" class="img_60">
    <img src="@/assets/video/index_model/61.png" style="display: none;" class="img_61">
    <img src="@/assets/video/index_model/62.png" style="display: none;" class="img_62">
    <img src="@/assets/video/index_model/63.png" style="display: none;" class="img_63">
    <img src="@/assets/video/index_model/64.png" style="display: none;" class="img_64">
    <img src="@/assets/video/index_model/65.png" style="display: none;" class="img_65">
    <img src="@/assets/video/index_model/66.png" style="display: none;" class="img_66">
    <img src="@/assets/video/index_model/67.png" style="display: none;" class="img_67">
    <img src="@/assets/video/index_model/68.png" style="display: none;" class="img_68">
    <img src="@/assets/video/index_model/69.png" style="display: none;" class="img_69">
    <img src="@/assets/video/index_model/70.png" style="display: none;" class="img_70">
    <img src="@/assets/video/index_model/71.png" style="display: none;" class="img_71">
    <img src="@/assets/video/index_model/72.png" style="display: none;" class="img_72">
    <img src="@/assets/video/index_model/73.png" style="display: none;" class="img_73">
    <img src="@/assets/video/index_model/74.png" style="display: none;" class="img_74">
    <img src="@/assets/video/index_model/75.png" style="display: none;" class="img_75">
    <img src="@/assets/video/index_model/76.png" style="display: none;" class="img_76">
    <img src="@/assets/video/index_model/77.png" style="display: none;" class="img_77">
    <img src="@/assets/video/index_model/78.png" style="display: none;" class="img_78">
    <img src="@/assets/video/index_model/79.png" style="display: none;" class="img_79">
    <img src="@/assets/video/index_model/80.png" style="display: none;" class="img_80">
    <img src="@/assets/video/index_model/81.png" style="display: none;" class="img_81">
    <img src="@/assets/video/index_model/82.png" style="display: none;" class="img_82">
    <img src="@/assets/video/index_model/83.png" style="display: none;" class="img_83">
    <img src="@/assets/video/index_model/84.png" style="display: none;" class="img_84">
    <img src="@/assets/video/index_model/85.png" style="display: none;" class="img_85">
    <img src="@/assets/video/index_model/86.png" style="display: none;" class="img_86">
    <img src="@/assets/video/index_model/87.png" style="display: none;" class="img_87">
    <img src="@/assets/video/index_model/88.png" style="display: none;" class="img_88">
    <img src="@/assets/video/index_model/89.png" style="display: none;" class="img_89">
    <img src="@/assets/video/index_model/90.png" style="display: none;" class="img_90">
    <img src="@/assets/video/index_model/91.png" style="display: none;" class="img_91">
    <img src="@/assets/video/index_model/92.png" style="display: none;" class="img_92">
    <img src="@/assets/video/index_model/93.png" style="display: none;" class="img_93">
    <img src="@/assets/video/index_model/94.png" style="display: none;" class="img_94">
    <img src="@/assets/video/index_model/95.png" style="display: none;" class="img_95">
    <img src="@/assets/video/index_model/96.png" style="display: none;" class="img_96">
    <img src="@/assets/video/index_model/97.png" style="display: none;" class="img_97">
    <img src="@/assets/video/index_model/98.png" style="display: none;" class="img_98">
  </div>

  <div class="ser_page" style="position: fixed;z-index: -999;">
    <div class="part2">
      <div class="float"></div>
    </div>
    <div class="part3">
      <div class="right">
        <div class="simg"></div>
      </div>
    </div>
  </div>

</template>

<script setup>
import { WOW } from 'wowjs'
import '@/assets/js/jarallax.js'

import '@/assets/js/index.js'
import '@/assets/js/jquery.num.js'

import '@/assets/js/tween.min.js'
import '@/assets/js/tweenmax.min.js'

import { getBanner, getModelCards, getNewsRecommend, partMain, serveMain, getHomeRecommendIndustry, selectPublishDataById } from '@/services/index.js'
import { onMounted, ref, onBeforeUnmount, watch } from 'vue'
import formatImg, { formatUrlToSpace, formatUrlToLine } from '@/utils/formatImg.js'

import { useI18n } from 'vue-i18n'
const { t } = useI18n()

let bannerMode = ref(true)

const bannerInfo = ref([])
const mBannerInfo = ref([])
const bannerbg = ref([])
const aniBannerInfo = ref([])
const ip2title = ref([])
const modelList = ref([])
const ip3title = ref([])
const recommendNews = ref([])
const recommendIndustry = ref([])
const serList = ref([])
const ip4title = ref([])
const numbers = ref([])
const getInfo = () => {
  getModelCards(2).then(res => {
    console.log('modelList', res);
    modelList.value = res.data
  })
  getNewsRecommend().then(res => {
    recommendNews.value = res.data
  })

  getHomeRecommendIndustry(2).then(res => {
    console.log('getHomeRecommendIndustry', res)
    recommendIndustry.value = res.data
    console.log('recommendIndustry', recommendIndustry.value);
    ip4Init()
  })
  // PC端banner
  getBanner({
    bannerTypeId: 15,
    status: 2
  }).then(res => {
    console.log('index', res);

    init()
    bannerInfo.value = res.data
  })
  // 移动端banner
  getBanner({
    bannerTypeId: 14,
    status: 2
  }).then(res => {
    console.log('index2', res);
    mBannerInfo.value = res.data
  })
  getBanner({
    bannerTypeId: 9,
    status: 2
  }).then(res => {
    console.log('anibanner', res)
    if (res.data) {
      if (res.data.length > 0) {
        bannerMode.value = false
      } else {
        bannerMode.value = true
      }
    }
    aniBannerInfo.value = res?.data[0]
  })
  serveMain({
    typeId: 16,
    status: 2
  }).then(res => {
    // console.log(res)
    numbers.value = res.data
  })

  selectPublishDataById(24).then(response => {
    partMain(24, 2).then(res => {
      console.log('ip3title', res)
      ip3title.value = res.data
    })
  })
  selectPublishDataById(23).then(response => {
    partMain(23, 2).then(res => {
      console.log('ip2title', res)
      ip2title.value = res.data
    })
  })
  selectPublishDataById(22).then(response => {
    partMain(22, 2).then(res => {
      console.log('ip4title', res)
      ip4title.value = res.data
    })
  })
  serveMain({
    typeId: 21,
    status: 2
  }).then(res => {
    // console.log('serList', res)
    serList.value = res.data
  })
}
import { useRouter } from 'vue-router'
const router = useRouter()
const switchTab = (path) => {
  window.routerPush(formatUrlToLine(path))
}
const jumpUrl = (url) => {
  if (!url) return
  if (url.startsWith('http') || url.startsWith('weixin://')) {
    window.open(url, '_blank')
  } else {
    window.routerPush(formatUrlToLine(url))
  }
}
const init = () => {
  $(function () {
    var h = parseInt($(".mx_pic").css("height"))
    function parallax() {
      const scrolled = $(window).scrollTop();
      $('.parallaxt').css("transform", "translate3d(0," + (0 - (scrolled * 0.2)) + "px,0)");
      $('.parallaxto').css('opacity', 1 - (scrolled * 0.0014));
      $('.parallaxto1').css('opacity', 0.0105 * h - (scrolled * 0.0009));
      var opx = -0.0027778 * h + (scrolled * 0.0009)
      if (opx >= 0) {
        $(".i_part1>.boxs .txt").addClass("show")
      } else {
        $(".i_part1>.boxs .txt").removeClass("show")
      }

      if (opx >= 0.002136 * h) {
        $(".i_part1>.boxs").addClass("show1")
      } else {
        $(".i_part1>.boxs").removeClass("show1")
      }

      if (opx >= 0.0029 * h) {
        $(".i_part1>.boxs").addClass("show2")
      } else {
        $(".i_part1>.boxs").removeClass("show2")
      }

      if (opx >= 0.0034 * h) {
        $(".i_partis").addClass("show")
        $(".i_parti .boxs").removeClass("hide")
      } else {
        $(".i_partis").removeClass("show")
        $(".i_parti .boxs").addClass("hide")
      }
    }
    $(window).scroll(function (e) {
      parallax();
    })


    $(".i_parti .boxs .box").hover(function () {
      var index = $(this).index()
      $(".i_parti .pic_box .pic").eq(index).addClass("on").siblings().removeClass("on")
    })
  })

}

const ip4Init = () => {

  $(function () {
    const ww = $(window).width()
    const wh = $(window).height()
    // part4
    const ip4 = document.querySelector('.i_part4')
    const ip4b = document.querySelector('.i_part4 .boxss')
    let scrolled = $(window).scrollTop();
    let move = - (scrolled - $(ip4).offset().top)
    const mostMove = - ($('.i_part4 .boxss .boxs').width() - ww)
    move >= mostMove ? $('.i_part4 .boxss .boxs').css('transform', `translateX(${move}px)`) : $('.i_part4 .boxss .boxs').css('transform', `translateX(${mostMove}px)`)
    function parallax1() {
      scrolled = $(window).scrollTop();
      $(ip4).css('height', wh + 0.7 * ww * $('.i_part4 .boxss .boxs .box').length)
      ip4b.getBoundingClientRect().top <= 0 ? $('.i_part4 .boxss>.txt').addClass('top') : $('.i_part4 .boxss>.txt').removeClass('top')
      move = - (scrolled - $(ip4).offset().top)
      if (ip4b.getBoundingClientRect().top == 0) {
        move >= mostMove ? $('.i_part4 .boxss .boxs').css('transform', `translateX(${move}px)`) : $('.i_part4 .boxss .boxs').css('transform', `translateX(${mostMove}px)`)
      } else if (ip4b.getBoundingClientRect().top > 0) {
        $('.i_part4 .boxss .boxs').css('transform', `translateX(${0}px)`)
      }
    }
    $(window).scroll(function (e) {
      parallax1()
    })
  })
}
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const modules = ref([Autoplay, Navigation, Pagination, Scrollbar, A11y])


const swiperBanner = {
  speed: 1000,
  slidesPerView: 1,
  pagination: {
    el: '.i_ban .swiper-pagination'
  },
  navigation: {
    nextEl: '.i_ban  .next',
    prevEl: '.i_ban  .prev',
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  }
}

const swiper1m = {
  speed: 1000,
  slidesPerView: 1,

  pagination: {
    el: '.i_part1.m .swiper-pagination'
  }
}
const swiper3m = {
  speed: 1000,
  slidesPerView: 1,
  spaceBetween: 10,
  breakpoints: {
    688: {
      slidesPerView: 2,
    }
  },
  scrollbar: {
    el: '.i_part3 .boxs.m .swiper-scrollbar'
  }
}
const swiper4m = {
  speed: 1000,
  slidesPerView: 1.5,
  spaceBetween: 15,
  freeMode: true,
  breakpoints: {
    688: {
      slidesPerView: 2,
    }
  },
}

onMounted(() => {
  new WOW({ live: false }).init()

  getInfo()
  $(function () {
    $('.header .con .h_left .h_nav>li').removeClass('act')
    $('.header .con .h_left .h_nav>li .xl .item').removeClass('act')
    $('.footer').addClass('white')
  })

})

onBeforeUnmount(() => {
  $('.footer').removeClass('white')
})
let timer1
const isLoading = ref(null)
const routerChange = () => {
  isLoading.value = true
  timer1 = setTimeout(() => {
    isLoading.value = false
    clearTimeout(timer1)
  }, 300)
}
watch(
  () => router.currentRoute.value,
  (newValue) => {
    routerChange()
  },
  { immediate: true }
)

</script>


<style scoped>
.i_ban .swiper-pagination {
  bottom: 0.4rem;
}

.i_ban .swiper-pagination :deep(.swiper-pagination-bullet) {
  width: 0.2rem;
  height: 0.06rem;
  opacity: 0.5;
  background-color: #fff;
  border-radius: 0.03rem;
  transition: all 0.5s;
}

.i_ban .swiper-pagination :deep(.swiper-pagination-bullet-active) {
  opacity: 1;
  width: 0.34rem;
}

.loading {
  background-color: #fff;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  animation: toOpacity 0.3s forwards;
}

@keyframes toOpacity {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@media screen and (max-width: 1024px), (pointer: coarse) {}
</style>